export enum ICD {
  /**
   * System Information et Repertoire des Entreprise et des Etablissements: SIRENE
   */
  SystemInformationEtRepertoireDesEntrepriseEtDesEtablissementsSirene = "0002",
  /**
   * Codification Numerique des Etablissments Financiers En Belgique
   */
  CodificationNumeriqueDesEtablissmentsFinanciersEnBelgique = "0003",
  /**
   * NBS/OSI NETWORK
   */
  NbsOsiNetwork = "0004",
  /**
   * USA FED GOV OSI NETWORK
   */
  UsaFedGovOsiNetwork = "0005",
  /**
   * USA DOD OSI NETWORK
   */
  UsaDodOsiNetwork = "0006",
  /**
   * Organisationsnummer
   */
  Organisationsnummer = "0007",
  /**
   * LE NUMERO NATIONAL
   */
  LeNumeroNational = "0008",
  /**
   * SIRET-CODE
   */
  SiretCode = "0009",
  /**
   * Organizational Identifiers for Structured Names under ISO 9541 Part 2
   */
  OrganizationalIdentifiersForStructuredNamesUnderIso9541Part2 = "0010",
  /**
   * International Code Designator for the Identification of OSI-based, Amateur Radio Organizations, Network Objects and Application Services.
   */
  InternationalCodeDesignatorForIdentificationOsiBasedAmateurRadioOrganizationsNetworkObjectsAndApplicationServices = "0011",
  /**
   * European Computer Manufacturers Association: ECMA
   */
  EuropeanComputerManufacturersAssociationEcma = "0012",
  /**
   * VSA FTP CODE (FTP = File Transfer Protocol)
   */
  VsaFtpCodeFtpFileTransferProtocol = "0013",
  /**
   * NIST/OSI Implememts' Workshop
   */
  NistOsiImplememtsWorkshop = "0014",
  /**
   * Electronic Data Interchange: EDI
   */
  ElectronicDataInterchangeEdi = "0015",
  /**
   * EWOS Object Identifiers
   */
  EwosObjectIdentifiers = "0016",
  /**
   * COMMON LANGUAGE
   */
  CommonLanguage = "0017",
  /**
   * SNA/OSI Network
   */
  SnaOsiNetwork = "0018",
  /**
   * Air Transport Industry Services Communications Network
   */
  AirTransportIndustryServicesCommunicationsNetwork = "0019",
  /**
   * European Laboratory for Particle Physics: CERN
   */
  EuropeanLaboratoryForParticlePhysicsCern = "0020",
  /**
   * SOCIETY FOR WORLDWIDE INTERBANK FINANCIAL, TELECOMMUNICATION S.W.I.F.T.
   */
  SocietyForWorldwideInterbankFinancialTelecommunicationSWIFT = "0021",
  /**
   * OSF Distributed Computing Object Identification
   */
  OsfDistributedComputingObjectIdentification = "0022",
  /**
   * Nordic University and Research Network: NORDUnet
   */
  NordicUniversityAndResearchNetworkNordunet = "0023",
  /**
   * Digital Equipment Corporation: DEC
   */
  DigitalEquipmentCorporationDec = "0024",
  /**
   * OSI ASIA-OCEANIA WORKSHOP
   */
  OsiAsiaOceaniaWorkshop = "0025",
  /**
   * NATO ISO 6523 ICDE coding scheme
   */
  NatoIso6523IcdeCodingScheme = "0026",
  /**
   * Aeronautical Telecommunications Network (ATN)
   */
  AeronauticalTelecommunicationsNetworkAtn = "0027",
  /**
   * International Standard ISO 6523
   */
  InternationalStandardIso6523 = "0028",
  /**
   * The All-Union Classifier of Enterprises and Organisations
   */
  TheAllUnionClassifierEnterprisesAndOrganisations = "0029",
  /**
   * AT&T/OSI Network
   */
  AtTOsiNetwork = "0030",
  /**
   * EDI Partner Identification Code
   */
  EdiPartnerIdentificationCode = "0031",
  /**
   * Telecom Australia
   */
  TelecomAustralia = "0032",
  /**
   * S G W OSI Internetwork
   */
  SGWOsiInternetwork = "0033",
  /**
   * Reuter Open Address Standard
   */
  ReuterOpenAddressStandard = "0034",
  /**
   * ISO 6523 - ICD
   */
  Iso6523Icd = "0035",
  /**
   * TeleTrust Object Identifiers
   */
  TeletrustObjectIdentifiers = "0036",
  /**
   * LY-tunnus
   */
  LyTunnus = "0037",
  /**
   * The Australian GOSIP Network
   */
  TheAustralianGosipNetwork = "0038",
  /**
   * The OZ DOD OSI Network
   */
  TheOzDodOsiNetwork = "0039",
  /**
   * Unilever Group Companies
   */
  UnileverGroupCompanies = "0040",
  /**
   * Citicorp Global Information Network
   */
  CiticorpGlobalInformationNetwork = "0041",
  /**
   * DBP Telekom Object Identifiers
   */
  DbpTelekomObjectIdentifiers = "0042",
  /**
   * HydroNETT
   */
  Hydronett = "0043",
  /**
   * Thai Industrial Standards Institute (TISI)
   */
  ThaiIndustrialStandardsInstituteTisi = "0044",
  /**
   * ICI Company Identification System
   */
  IciCompanyIdentificationSystem = "0045",
  /**
   * FUNLOC
   */
  Funloc = "0046",
  /**
   * BULL ODI/DSA/UNIX Network
   */
  BullOdiDsaUnixNetwork = "0047",
  /**
   * OSINZ
   */
  Osinz = "0048",
  /**
   * Auckland Area Health
   */
  AucklandAreaHealth = "0049",
  /**
   * Firmenich
   */
  Firmenich = "0050",
  /**
   * AGFA-DIS
   */
  AgfaDis = "0051",
  /**
   * Society of Motion Picture and Television Engineers (SMPTE)
   */
  SocietyMotionPictureAndTelevisionEngineersSmpte = "0052",
  /**
   * Migros_Network M_NETOPZ
   */
  Migros_networkM_netopz = "0053",
  /**
   * ISO6523 - ICDPCR
   */
  Iso6523Icdpcr = "0054",
  /**
   * Energy Net
   */
  EnergyNet = "0055",
  /**
   * Nokia Object Identifiers (NOI)
   */
  NokiaObjectIdentifiersNoi = "0056",
  /**
   * Saint Gobain
   */
  SaintGobain = "0057",
  /**
   * Siemens Corporate Network
   */
  SiemensCorporateNetwork = "0058",
  /**
   * DANZNET
   */
  Danznet = "0059",
  /**
   * Data Universal Numbering System (D-U-N-S Number)
   */
  DataUniversalNumberingSystemDUNSNumber = "0060",
  /**
   * SOFFEX OSI
   */
  SoffexOsi = "0061",
  /**
   * KPN OVN
   */
  KpnOvn = "0062",
  /**
   * ascomOSINet
   */
  Ascomosinet = "0063",
  /**
   * UTC: Uniforme Transport Code
   */
  UtcUniformeTransportCode = "0064",
  /**
   * SOLVAY OSI CODING
   */
  SolvayOsiCoding = "0065",
  /**
   * Roche Corporate Network
   */
  RocheCorporateNetwork = "0066",
  /**
   * ZellwegerOSINet
   */
  Zellwegerosinet = "0067",
  /**
   * Intel Corporation OSI
   */
  IntelCorporationOsi = "0068",
  /**
   * SITA Object Identifier Tree
   */
  SitaObjectIdentifierTree = "0069",
  /**
   * DaimlerChrysler Corporate Network
   */
  DaimlerchryslerCorporateNetwork = "0070",
  /**
   * LEGO /OSI NETWORK
   */
  LegoOsiNetwork = "0071",
  /**
   * NAVISTAR/OSI Network
   */
  NavistarOsiNetwork = "0072",
  /**
   * ICD Formatted ATM address
   */
  IcdFormattedAtmAddress = "0073",
  /**
   * ARINC
   */
  Arinc = "0074",
  /**
   * Alcanet/Alcatel-Alsthom Corporate Network
   */
  AlcanetAlcatelAlsthomCorporateNetwork = "0075",
  /**
   * Sistema Italiano di Identificazione di ogetti gestito da UNINFO
   */
  SistemaItalianoDiIdentificazioneDiOgettiGestitoDaUninfo = "0076",
  /**
   * Sistema Italiano di Indirizzamento di Reti OSI Gestito da UNINFO
   */
  SistemaItalianoDiIndirizzamentoDiRetiOsiGestitoDaUninfo = "0077",
  /**
   * Mitel terminal or switching equipment
   */
  MitelTerminalOrSwitchingEquipment = "0078",
  /**
   * ATM Forum
   */
  AtmForum = "0079",
  /**
   * UK National Health Service Scheme, (EDIRA compliant)
   */
  UkNationalHealthServiceSchemeEdiraCompliant = "0080",
  /**
   * International NSAP
   */
  InternationalNsap = "0081",
  /**
   * Norwegian Telecommunications Authority's, NTA'S, EDI, identifier scheme (EDIRA compliant)
   */
  NorwegianTelecommunicationsAuthoritysNtasEdiIdentifierSchemeEdiraCompliant = "0082",
  /**
   * Advanced Telecommunications Modules Limited, Corporate Network
   */
  AdvancedTelecommunicationsModulesLimitedCorporateNetwork = "0083",
  /**
   * Athens Chamber of Commerce & Industry Scheme (EDIRA compliant)
   */
  AthensChamberCommerceIndustrySchemeEdiraCompliant = "0084",
  /**
   * Swiss Chambers of Commerce Scheme (EDIRA) compliant
   */
  SwissChambersCommerceSchemeEdiraCompliant = "0085",
  /**
   * United States Council for International Business (USCIB) Scheme, (EDIRA compliant)
   */
  UnitedStatesCouncilForInternationalBusinessUscibSchemeEdiraCompliant = "0086",
  /**
   * National Federation of Chambers of Commerce & Industry of Belgium, Scheme (EDIRA compliant)
   */
  NationalFederationChambersCommerceIndustryBelgiumSchemeEdiraCompliant = "0087",
  /**
   * EAN Location Code
   */
  EanLocationCode = "0088",
  /**
   * The Association of British Chambers of Commerce Ltd. Scheme, (EDIRA compliant)
   */
  TheAssociationBritishChambersCommerceLtdSchemeEdiraCompliant = "0089",
  /**
   * Internet IP addressing - ISO 6523 ICD encoding
   */
  InternetIpAddressingIso6523IcdEncoding = "0090",
  /**
   * Cisco Sysytems / OSI Network
   */
  CiscoSysytemsOsiNetwork = "0091",
  /**
   * Revenue Canada Business Number Registration (EDIRA compliant)
   */
  RevenueCanadaBusinessNumberRegistrationEdiraCompliant = "0093",
  /**
   * DEUTSCHER INDUSTRIE- UND HANDELSTAG (DIHT) Scheme (EDIRA compliant)
   */
  DeutscherIndustrieUndHandelstagDihtSchemeEdiraCompliant = "0094",
  /**
   * Hewlett - Packard Company Internal AM Network
   */
  HewlettPackardCompanyInternalAmNetwork = "0095",
  /**
   * DANISH CHAMBER OF COMMERCE Scheme (EDIRA compliant)
   */
  DanishChamberOfCommerceSchemeEdiraCompliant = "0096",
  /**
   * FTI - Ediforum Italia, (EDIRA compliant)
   */
  FtiEdiforumItaliaEdiraCompliant = "0097",
  /**
   * CHAMBER OF COMMERCE TEL AVIV-JAFFA Scheme (EDIRA compliant)
   */
  ChamberOfCommerceTelAvivJaffaSchemeEdiraCompliant = "0098",
  /**
   * Siemens Supervisory Systems Network
   */
  SiemensSupervisorySystemsNetwork = "0099",
  /**
   * PNG_ICD Scheme
   */
  Png_icdScheme = "0100",
  /**
   * South African Code Allocation
   */
  SouthAfricanCodeAllocation = "0101",
  /**
   * HEAG
   */
  Heag = "0102",
  /**
   * BT - ICD Coding System
   */
  BtIcdCodingSystem = "0104",
  /**
   * Portuguese Chamber of Commerce and Industry Scheme (EDIRA compliant)
   */
  PortugueseChamberCommerceAndIndustrySchemeEdiraCompliant = "0105",
  /**
   * Vereniging van Kamers van Koophandel en Fabrieken in Nederland (Association of Chambers of Commerce and Industry in the Netherlands), Scheme (EDIRA compliant)
   */
  VerenigingVanKamersVanKoophandelEnFabriekenInNederlandAssociationChambersCommerceAndIndustryInNetherlandsSchemeEdiraCompliant = "0106",
  /**
   * Association of Swedish Chambers of Commerce and Industry Scheme (EDIRA compliant)
   */
  AssociationSwedishChambersCommerceAndIndustrySchemeEdiraCompliant = "0107",
  /**
   * Australian Chambers of Commerce and Industry Scheme (EDIRA compliant)
   */
  AustralianChambersCommerceAndIndustrySchemeEdiraCompliant = "0108",
  /**
   * BellSouth ICD AESA (ATM End System Address)
   */
  BellsouthIcdAesaAtmEndSystemAddress = "0109",
  /**
   * Bell Atlantic
   */
  BellAtlantic = "0110",
  /**
   * Object Identifiers
   */
  ObjectIdentifiers = "0111",
  /**
   * ISO register for Standards producing Organizations
   */
  IsoRegisterForStandardsProducingOrganizations = "0112",
  /**
   * OriginNet
   */
  Originnet = "0113",
  /**
   * Check Point Software Technologies
   */
  CheckPointSoftwareTechnologies = "0114",
  /**
   * Pacific Bell Data Communications Network
   */
  PacificBellDataCommunicationsNetwork = "0115",
  /**
   * PSS Object Identifiers
   */
  PssObjectIdentifiers = "0116",
  /**
   * STENTOR-ICD CODING SYSTEM
   */
  StentorIcdCodingSystem = "0117",
  /**
   * ATM-Network ZN'96
   */
  AtmNetworkZn96 = "0118",
  /**
   * MCI / OSI Network
   */
  MciOsiNetwork = "0119",
  /**
   * Advantis
   */
  Advantis = "0120",
  /**
   * Affable Software Data Interchange Codes
   */
  AffableSoftwareDataInterchangeCodes = "0121",
  /**
   * BB-DATA GmbH
   */
  BbDataGmbh = "0122",
  /**
   * BASF Company ATM-Network
   */
  BasfCompanyAtmNetwork = "0123",
  /**
   * IOTA Identifiers for Organizations for Telecommunications Addressing using the ICD system format defined in ISO/IEC 8348
   */
  IotaIdentifiersForOrganizationsForTelecommunicationsAddressingUsingIcdSystemFormatDefinedInIsoIec8348 = "0124",
  /**
   * Henkel Corporate Network (H-Net)
   */
  HenkelCorporateNetworkHNet = "0125",
  /**
   * GTE/OSI Network
   */
  GteOsiNetwork = "0126",
  /**
   * Dresdner Bank Corporate Network
   */
  DresdnerBankCorporateNetwork = "0127",
  /**
   * BCNR (Swiss Clearing Bank Number)
   */
  BcnrSwissClearingBankNumber = "0128",
  /**
   * BPI (Swiss Business Partner Identification) code
   */
  BpiSwissBusinessPartnerIdentificationCode = "0129",
  /**
   * Directorates of the European Commission
   */
  DirectoratesEuropeanCommission = "0130",
  /**
   * Code for the Identification of National Organizations
   */
  CodeForIdentificationNationalOrganizations = "0131",
  /**
   * Certicom Object Identifiers
   */
  CerticomObjectIdentifiers = "0132",
  /**
   * TC68 OID
   */
  Tc68Oid = "0133",
  /**
   * Infonet Services Corporation
   */
  InfonetServicesCorporation = "0134",
  /**
   * SIA Object Identifiers
   */
  SiaObjectIdentifiers = "0135",
  /**
   * Cable & Wireless Global ATM End-System Address Plan
   */
  CableWirelessGlobalAtmEndSystemAddressPlan = "0136",
  /**
   * Global AESA scheme
   */
  GlobalAesaScheme = "0137",
  /**
   * France Telecom ATM End System Address Plan
   */
  FranceTelecomAtmEndSystemAddressPlan = "0138",
  /**
   * Savvis Communications AESA:.
   */
  SavvisCommunicationsAesa = "0139",
  /**
   * Toshiba Organizations, Partners, And Suppliers' (TOPAS) Code
   */
  ToshibaOrganizationsPartnersAndSuppliersTopasCode = "0140",
  /**
   * NATO Commercial and Government Entity system
   */
  NatoCommercialAndGovernmentEntitySystem = "0141",
  /**
   * SECETI Object Identifiers
   */
  SecetiObjectIdentifiers = "0142",
  /**
   * EINESTEINet AG
   */
  EinesteinetAg = "0143",
  /**
   * DoDAAC (Department of Defense Activity Address Code)
   */
  DodaacDepartmentDefenseActivityAddressCode = "0144",
  /**
   * DGCP (Direction Générale de la Comptabilité Publique)administrative accounting identification scheme
   */
  DgcpDirectionGénéraleDeLaComptabilitéPubliqueAdministrativeAccountingIdentificationScheme = "0145",
  /**
   * DGI (Direction Générale des Impots) code
   */
  DgiDirectionGénéraleDesImpotsCode = "0146",
  /**
   * Standard Company Code
   */
  StandardCompanyCode = "0147",
  /**
   * ITU (International Telecommunications Union)Data Network Identification Codes (DNIC)
   */
  ItuInternationalTelecommunicationsUnionDataNetworkIdentificationCodesDnic = "0148",
  /**
   * Global Business Identifier
   */
  GlobalBusinessIdentifier = "0149",
  /**
   * Madge Networks Ltd- ICD ATM Addressing Scheme
   */
  MadgeNetworksLtdIcdAtmAddressingScheme = "0150",
  /**
   * Australian Business Number (ABN) Scheme
   */
  AustralianBusinessNumberAbnScheme = "0151",
  /**
   * Edira Scheme Identifier Code
   */
  EdiraSchemeIdentifierCode = "0152",
  /**
   * Concert Global Network Services ICD AESA
   */
  ConcertGlobalNetworkServicesIcdAesa = "0153",
  /**
   * Identification number of economic subjects: (ICO)
   */
  IdentificationNumberEconomicSubjectsIco = "0154",
  /**
   * Global Crossing AESA (ATM End System Address)
   */
  GlobalCrossingAesaAtmEndSystemAddress = "0155",
  /**
   * AUNA
   */
  Auna = "0156",
  /**
   * ATM interconnection with the Dutch KPN Telecom
   */
  AtmInterconnectionWithDutchKpnTelecom = "0157",
  /**
   * Identification number of economic subject (ICO) Act on State Statistics of 29 November 2'001, § 27
   */
  IdentificationNumberEconomicSubjectIcoActOnStateStatistics29November200127 = "0158",
  /**
   * ACTALIS Object Identifiers
   */
  ActalisObjectIdentifiers = "0159",
  /**
   * GTIN - Global Trade Item Number
   */
  GtinGlobalTradeItemNumber = "0160",
  /**
   * ECCMA Open Technical Directory
   */
  EccmaOpenTechnicalDirectory = "0161",
  /**
   * CEN/ISSS Object Identifier Scheme
   */
  CenIsssObjectIdentifierScheme = "0162",
  /**
   * US-EPA Facility Identifier
   */
  UsEpaFacilityIdentifier = "0163",
  /**
   * TELUS Corporation
   */
  TelusCorporation = "0164",
  /**
   * FIEIE Object identifiers
   */
  FieieObjectIdentifiers = "0165",
  /**
   * Swissguide Identifier Scheme
   */
  SwissguideIdentifierScheme = "0166",
  /**
   * Priority Telecom ATM End System Address Plan
   */
  PriorityTelecomAtmEndSystemAddressPlan = "0167",
  /**
   * Vodafone Ireland OSI Addressing
   */
  VodafoneIrelandOsiAddressing = "0168",
  /**
   * Swiss Federal Business Identification Number. Central Business names Index (zefix) Identification Number
   */
  SwissFederalBusinessIdentificationNumberCentralBusinessNamesIndexZefixIdentificationNumber = "0169",
  /**
   * Teikoku Company Code
   */
  TeikokuCompanyCode = "0170",
  /**
   * Luxembourg CP & CPS (Certification Policy and Certification Practice Statement) Index
   */
  LuxembourgCpCpsCertificationPolicyAndCertificationPracticeStatementIndex = "0171",
  /**
   * Project Group “Lists of Properties” (PROLIST®)
   */
  ProjectGroupListsPropertiesProlist = "0172",
  /**
   * eCI@ss
   */
  EciSs = "0173",
  /**
   * StepNexus
   */
  Stepnexus = "0174",
  /**
   * Siemens AG
   */
  SiemensAg = "0175",
  /**
   * Paradine GmbH
   */
  ParadineGmbh = "0176",
  /**
   * Odette International Limited
   */
  OdetteInternationalLimited = "0177",
  /**
   * Route1 MobiNET
   */
  Route1Mobinet = "0178",
  /**
   * Penango Object Identifiers
   */
  PenangoObjectIdentifiers = "0179",
  /**
   * Lithuanian military PKI
   */
  LithuanianMilitaryPki = "0180",
  /**
   * Numéro d'identification suisse des enterprises (IDE), Swiss Unique Business Identification Number (UIDB)
   */
  NuméroDidentificationSuisseDesEnterprisesIdeSwissUniqueBusinessIdentificationNumberUidb = "0183",
  /**
   * DIGSTORG
   */
  Digstorg = "0184",
  /**
   * Perceval Object Code
   */
  PercevalObjectCode = "0185",
  /**
   * TrustPoint Object Identifiers
   */
  TrustpointObjectIdentifiers = "0186",
  /**
   * Amazon Unique Identification Scheme
   */
  AmazonUniqueIdentificationScheme = "0187",
  /**
   * Corporate Number of The Social Security and Tax Number System
   */
  CorporateNumberTheSocialSecurityAndTaxNumberSystem = "0188",
  /**
   * European Business Identifier (EBID)
   */
  EuropeanBusinessIdentifierEbid = "0189",
  /**
   * Organisatie Indentificatie Nummer (OIN)
   */
  OrganisatieIndentificatieNummerOin = "0190",
  /**
   * Company Code (Estonia)
   */
  CompanyCodeEstonia = "0191",
  /**
   * Organisasjonsnummer
   */
  Organisasjonsnummer = "0192",
  /**
   * UBL.BE Party Identifier
   */
  UblBePartyIdentifier = "0193",
  /**
   * KOIOS Open Technical Dictionary
   */
  KoiosOpenTechnicalDictionary = "0194",
  /**
   * Singapore Nationwide E-lnvoice Framework
   */
  SingaporeNationwideELnvoiceFramework = "0195",
  /**
   * Icelandic identifier - Íslensk kennitala
   */
  IcelandicIdentifierÍslenskKennitala = "0196",
  /**
   * APPLiA Pl Standard
   */
  AppliaPlStandard = "0197",
  /**
   * ERSTORG
   */
  Erstorg = "0198",
  /**
   * Legal Entity Identifier (LEI)
   */
  LegalEntityIdentifierLei = "0199",
  /**
   * Legal entity code (Lithuania)
   */
  LegalEntityCodeLithuania = "0200",
  /**
   * Codice Univoco Unità Organizzativa iPA
   */
  CodiceUnivocoUnitàOrganizzativaIpa = "0201",
  /**
   * Indirizzo di Posta Elettronica Certificata
   */
  IndirizzoDiPostaElettronicaCertificata = "0202",
  /**
   * eDelivery Network Participant identifier
   */
  EdeliveryNetworkParticipantIdentifier = "0203",
  /**
   * Leitweg-ID
   */
  LeitwegId = "0204",
  /**
   * CODDEST
   */
  Coddest = "0205",
  /**
   * Registre du Commerce et de l’Industrie : RCI
   */
  RegistreDuCommerceEtDeLIndustrieRci = "0206",
  /**
   * PiLog Ontology Codification Identifier (POCI)
   */
  PilogOntologyCodificationIdentifierPoci = "0207",
  /**
   * Numero d'entreprise / ondernemingsnummer / Unternehmensnummer
   */
  NumeroDentrepriseOndernemingsnummerUnternehmensnummer = "0208",
  /**
   * GS1 identification keys
   */
  Gs1IdentificationKeys = "0209",
  /**
   * CODICE FISCALE
   */
  CodiceFiscale = "0210",
  /**
   * PARTITA IVA
   */
  PartitaIva = "0211",
  /**
   * Finnish Organization Identifier
   */
  FinnishOrganizationIdentifier = "0212",
  /**
   * Finnish Organization Value Add Tax Identifier
   */
  FinnishOrganizationValueAddTaxIdentifier = "0213",
  /**
   * Tradeplace TradePI Standard
   */
  TradeplaceTradepiStandard = "0214",
  /**
   * Net service ID
   */
  NetServiceId = "0215",
  /**
   * OVTcode
   */
  Ovtcode = "0216",
  /**
   * The Netherlands Chamber of Commerce and Industry establishment number
   */
  TheNetherlandsChamberCommerceAndIndustryEstablishmentNumber = "0217",
  /**
   * Unified registration number (Latvia)
   */
  UnifiedRegistrationNumberLatvia = "0218",
  /**
   * Taxpayer registration code (Latvia)
   */
  TaxpayerRegistrationCodeLatvia = "0219",
  /**
   * The Register of Natural Persons (Latvia)
   */
  TheRegisterNaturalPersonsLatvia = "0220",
  /**
   * The registered number of the qualified invoice issuer
   */
  TheRegisteredNumberQualifiedInvoiceIssuer = "0221",
  /**
   * Metadata Registry Support
   */
  MetadataRegistrySupport = "0222",
  /**
   * EU based company
   */
  EuBasedCompany = "0223",
  /**
   * FTCTC CODE ROUTAGE
   */
  FtctcCodeRoutage = "0224",
  /**
   * FRCTC ELECTRONIC ADDRESS
   */
  FrctcElectronicAddress = "0225",
  /**
   * FRCTC Particulier
   */
  FrctcParticulier = "0226",
  /**
   * NON - EU based company
   */
  NonEuBasedCompany = "0227",
  /**
   * Répertoire des Entreprises et des Etablissements (RIDET)
   */
  RépertoireDesEntreprisesEtDesEtablissementsRidet = "0228",
  /**
   * T.A.H.I.T.I (traitement automatique hiérarchisé des institutions de Tahiti et des îles)
   */
  TAHITITraitementAutomatiqueHiérarchiséDesInstitutionsDeTahitiEtDesÎles = "0229",
  /**
   * National e-Invoicing Framework
   */
  NationalEInvoicingFramework = "0230",
  /**
   * Single taxable company (France)
   */
  SingleTaxableCompanyFrance = "0231",
  /**
   * NOBB product number
   */
  NobbProductNumber = "0232",
  /**
   * Description not known
   */
  DescriptionNotKnown = "0233",
  /**
   * Toimitusosoite ID
   */
  ToimitusosoiteId = "0234",
  /**
   * UAE Tax Identification Number (TIN)
   */
  UaeTaxIdentificationNumberTin = "0235",
  /**
   * Description not known
   */
  DescriptionNotKnown_Dup = "0236",
  /**
   * CPR (Danish person civil registration number)
   */
  CprDanishPersonCivilRegistrationNumber = "0237",
  /**
   * Plateforme.s agréée.s à la facturation électronique (PPF/PDP)
   */
  PlateformeSAgrééeSÀLaFacturationÉlectroniquePpfPdp = "0238",
  /**
   * EAEU
   */
  Eaeu = "0239",
  /**
   * Register of legal persons (in French : Répertoire des personnes morales)
   */
  RegisterLegalPersonsInFrenchRépertoireDesPersonnesMorales = "0240",
}

export function description(value: ICD): string {
  switch (value) {
    case ICD.SystemInformationEtRepertoireDesEntrepriseEtDesEtablissementsSirene:
      return "System Information et Repertoire des Entreprise et des Etablissements: SIRENE ";
    case ICD.CodificationNumeriqueDesEtablissmentsFinanciersEnBelgique:
      return "Codification Numerique des Etablissments Financiers En Belgique ";
    case ICD.NbsOsiNetwork:
      return "NBS/OSI NETWORK ";
    case ICD.UsaFedGovOsiNetwork:
      return "USA FED GOV OSI NETWORK ";
    case ICD.UsaDodOsiNetwork:
      return "USA DOD OSI NETWORK ";
    case ICD.Organisationsnummer:
      return "Organisationsnummer ";
    case ICD.LeNumeroNational:
      return "LE NUMERO NATIONAL ";
    case ICD.SiretCode:
      return "SIRET-CODE ";
    case ICD.OrganizationalIdentifiersForStructuredNamesUnderIso9541Part2:
      return "Organizational Identifiers for Structured Names under ISO 9541 Part 2 ";
    case ICD.InternationalCodeDesignatorForIdentificationOsiBasedAmateurRadioOrganizationsNetworkObjectsAndApplicationServices:
      return "International Code Designator for the Identification of OSI-based, Amateur Radio Organizations, Network Objects and Application Services. ";
    case ICD.EuropeanComputerManufacturersAssociationEcma:
      return "European Computer Manufacturers Association: ECMA ";
    case ICD.VsaFtpCodeFtpFileTransferProtocol:
      return "VSA FTP CODE (FTP = File Transfer Protocol) ";
    case ICD.NistOsiImplememtsWorkshop:
      return "NIST/OSI Implememts' Workshop ";
    case ICD.ElectronicDataInterchangeEdi:
      return "Electronic Data Interchange: EDI ";
    case ICD.EwosObjectIdentifiers:
      return "EWOS Object Identifiers ";
    case ICD.CommonLanguage:
      return "COMMON LANGUAGE ";
    case ICD.SnaOsiNetwork:
      return "SNA/OSI Network ";
    case ICD.AirTransportIndustryServicesCommunicationsNetwork:
      return "Air Transport Industry Services Communications Network ";
    case ICD.EuropeanLaboratoryForParticlePhysicsCern:
      return "European Laboratory for Particle Physics: CERN ";
    case ICD.SocietyForWorldwideInterbankFinancialTelecommunicationSWIFT:
      return "SOCIETY FOR WORLDWIDE INTERBANK FINANCIAL, TELECOMMUNICATION S.W.I.F.T. ";
    case ICD.OsfDistributedComputingObjectIdentification:
      return "OSF Distributed Computing Object Identification ";
    case ICD.NordicUniversityAndResearchNetworkNordunet:
      return "Nordic University and Research Network: NORDUnet ";
    case ICD.DigitalEquipmentCorporationDec:
      return "Digital Equipment Corporation: DEC ";
    case ICD.OsiAsiaOceaniaWorkshop:
      return "OSI ASIA-OCEANIA WORKSHOP ";
    case ICD.NatoIso6523IcdeCodingScheme:
      return "NATO ISO 6523 ICDE coding scheme ";
    case ICD.AeronauticalTelecommunicationsNetworkAtn:
      return "Aeronautical Telecommunications Network (ATN) ";
    case ICD.InternationalStandardIso6523:
      return "International Standard ISO 6523 ";
    case ICD.TheAllUnionClassifierEnterprisesAndOrganisations:
      return "The All-Union Classifier of Enterprises and Organisations ";
    case ICD.AtTOsiNetwork:
      return "AT&T/OSI Network ";
    case ICD.EdiPartnerIdentificationCode:
      return "EDI Partner Identification Code ";
    case ICD.TelecomAustralia:
      return "Telecom Australia ";
    case ICD.SGWOsiInternetwork:
      return "S G W OSI Internetwork ";
    case ICD.ReuterOpenAddressStandard:
      return "Reuter Open Address Standard ";
    case ICD.Iso6523Icd:
      return "ISO 6523 - ICD ";
    case ICD.TeletrustObjectIdentifiers:
      return "TeleTrust Object Identifiers ";
    case ICD.LyTunnus:
      return "LY-tunnus ";
    case ICD.TheAustralianGosipNetwork:
      return "The Australian GOSIP Network ";
    case ICD.TheOzDodOsiNetwork:
      return "The OZ DOD OSI Network ";
    case ICD.UnileverGroupCompanies:
      return "Unilever Group Companies ";
    case ICD.CiticorpGlobalInformationNetwork:
      return "Citicorp Global Information Network ";
    case ICD.DbpTelekomObjectIdentifiers:
      return "DBP Telekom Object Identifiers ";
    case ICD.Hydronett:
      return "HydroNETT ";
    case ICD.ThaiIndustrialStandardsInstituteTisi:
      return "Thai Industrial Standards Institute (TISI) ";
    case ICD.IciCompanyIdentificationSystem:
      return "ICI Company Identification System ";
    case ICD.Funloc:
      return "FUNLOC ";
    case ICD.BullOdiDsaUnixNetwork:
      return "BULL ODI/DSA/UNIX Network ";
    case ICD.Osinz:
      return "OSINZ ";
    case ICD.AucklandAreaHealth:
      return "Auckland Area Health ";
    case ICD.Firmenich:
      return "Firmenich ";
    case ICD.AgfaDis:
      return "AGFA-DIS ";
    case ICD.SocietyMotionPictureAndTelevisionEngineersSmpte:
      return "Society of Motion Picture and Television Engineers (SMPTE) ";
    case ICD.Migros_networkM_netopz:
      return "Migros_Network M_NETOPZ ";
    case ICD.Iso6523Icdpcr:
      return "ISO6523 - ICDPCR ";
    case ICD.EnergyNet:
      return "Energy Net ";
    case ICD.NokiaObjectIdentifiersNoi:
      return "Nokia Object Identifiers (NOI) ";
    case ICD.SaintGobain:
      return "Saint Gobain ";
    case ICD.SiemensCorporateNetwork:
      return "Siemens Corporate Network ";
    case ICD.Danznet:
      return "DANZNET ";
    case ICD.DataUniversalNumberingSystemDUNSNumber:
      return "Data Universal Numbering System (D-U-N-S Number) ";
    case ICD.SoffexOsi:
      return "SOFFEX OSI ";
    case ICD.KpnOvn:
      return "KPN OVN ";
    case ICD.Ascomosinet:
      return "ascomOSINet ";
    case ICD.UtcUniformeTransportCode:
      return "UTC: Uniforme Transport Code ";
    case ICD.SolvayOsiCoding:
      return "SOLVAY OSI CODING ";
    case ICD.RocheCorporateNetwork:
      return "Roche Corporate Network ";
    case ICD.Zellwegerosinet:
      return "ZellwegerOSINet ";
    case ICD.IntelCorporationOsi:
      return "Intel Corporation OSI ";
    case ICD.SitaObjectIdentifierTree:
      return "SITA Object Identifier Tree ";
    case ICD.DaimlerchryslerCorporateNetwork:
      return "DaimlerChrysler Corporate Network ";
    case ICD.LegoOsiNetwork:
      return "LEGO /OSI NETWORK ";
    case ICD.NavistarOsiNetwork:
      return "NAVISTAR/OSI Network ";
    case ICD.IcdFormattedAtmAddress:
      return "ICD Formatted ATM address ";
    case ICD.Arinc:
      return "ARINC ";
    case ICD.AlcanetAlcatelAlsthomCorporateNetwork:
      return "Alcanet/Alcatel-Alsthom Corporate Network ";
    case ICD.SistemaItalianoDiIdentificazioneDiOgettiGestitoDaUninfo:
      return "Sistema Italiano di Identificazione di ogetti gestito da UNINFO ";
    case ICD.SistemaItalianoDiIndirizzamentoDiRetiOsiGestitoDaUninfo:
      return "Sistema Italiano di Indirizzamento di Reti OSI Gestito da UNINFO ";
    case ICD.MitelTerminalOrSwitchingEquipment:
      return "Mitel terminal or switching equipment ";
    case ICD.AtmForum:
      return "ATM Forum ";
    case ICD.UkNationalHealthServiceSchemeEdiraCompliant:
      return "UK National Health Service Scheme, (EDIRA compliant) ";
    case ICD.InternationalNsap:
      return "International NSAP ";
    case ICD.NorwegianTelecommunicationsAuthoritysNtasEdiIdentifierSchemeEdiraCompliant:
      return "Norwegian Telecommunications Authority's, NTA'S, EDI, identifier scheme (EDIRA compliant) ";
    case ICD.AdvancedTelecommunicationsModulesLimitedCorporateNetwork:
      return "Advanced Telecommunications Modules Limited, Corporate Network ";
    case ICD.AthensChamberCommerceIndustrySchemeEdiraCompliant:
      return "Athens Chamber of Commerce & Industry Scheme (EDIRA compliant) ";
    case ICD.SwissChambersCommerceSchemeEdiraCompliant:
      return "Swiss Chambers of Commerce Scheme (EDIRA) compliant ";
    case ICD.UnitedStatesCouncilForInternationalBusinessUscibSchemeEdiraCompliant:
      return "United States Council for International Business (USCIB) Scheme, (EDIRA compliant) ";
    case ICD.NationalFederationChambersCommerceIndustryBelgiumSchemeEdiraCompliant:
      return "National Federation of Chambers of Commerce & Industry of Belgium, Scheme (EDIRA compliant) ";
    case ICD.EanLocationCode:
      return "EAN Location Code ";
    case ICD.TheAssociationBritishChambersCommerceLtdSchemeEdiraCompliant:
      return "The Association of British Chambers of Commerce Ltd. Scheme, (EDIRA compliant) ";
    case ICD.InternetIpAddressingIso6523IcdEncoding:
      return "Internet IP addressing - ISO 6523 ICD encoding ";
    case ICD.CiscoSysytemsOsiNetwork:
      return "Cisco Sysytems / OSI Network ";
    case ICD.RevenueCanadaBusinessNumberRegistrationEdiraCompliant:
      return "Revenue Canada Business Number Registration (EDIRA compliant) ";
    case ICD.DeutscherIndustrieUndHandelstagDihtSchemeEdiraCompliant:
      return "DEUTSCHER INDUSTRIE- UND HANDELSTAG (DIHT) Scheme (EDIRA compliant) ";
    case ICD.HewlettPackardCompanyInternalAmNetwork:
      return "Hewlett - Packard Company Internal AM Network ";
    case ICD.DanishChamberOfCommerceSchemeEdiraCompliant:
      return "DANISH CHAMBER OF COMMERCE Scheme (EDIRA compliant) ";
    case ICD.FtiEdiforumItaliaEdiraCompliant:
      return "FTI - Ediforum Italia, (EDIRA compliant) ";
    case ICD.ChamberOfCommerceTelAvivJaffaSchemeEdiraCompliant:
      return "CHAMBER OF COMMERCE TEL AVIV-JAFFA Scheme (EDIRA compliant) ";
    case ICD.SiemensSupervisorySystemsNetwork:
      return "Siemens Supervisory Systems Network ";
    case ICD.Png_icdScheme:
      return "PNG_ICD Scheme ";
    case ICD.SouthAfricanCodeAllocation:
      return "South African Code Allocation ";
    case ICD.Heag:
      return "HEAG ";
    case ICD.BtIcdCodingSystem:
      return "BT - ICD Coding System ";
    case ICD.PortugueseChamberCommerceAndIndustrySchemeEdiraCompliant:
      return "Portuguese Chamber of Commerce and Industry Scheme (EDIRA compliant) ";
    case ICD.VerenigingVanKamersVanKoophandelEnFabriekenInNederlandAssociationChambersCommerceAndIndustryInNetherlandsSchemeEdiraCompliant:
      return "Vereniging van Kamers van Koophandel en Fabrieken in Nederland (Association of Chambers of Commerce and Industry in the Netherlands), Scheme (EDIRA compliant) ";
    case ICD.AssociationSwedishChambersCommerceAndIndustrySchemeEdiraCompliant:
      return "Association of Swedish Chambers of Commerce and Industry Scheme (EDIRA compliant) ";
    case ICD.AustralianChambersCommerceAndIndustrySchemeEdiraCompliant:
      return "Australian Chambers of Commerce and Industry Scheme (EDIRA compliant) ";
    case ICD.BellsouthIcdAesaAtmEndSystemAddress:
      return "BellSouth ICD AESA (ATM End System Address) ";
    case ICD.BellAtlantic:
      return "Bell Atlantic ";
    case ICD.ObjectIdentifiers:
      return "Object Identifiers ";
    case ICD.IsoRegisterForStandardsProducingOrganizations:
      return "ISO register for Standards producing Organizations ";
    case ICD.Originnet:
      return "OriginNet ";
    case ICD.CheckPointSoftwareTechnologies:
      return "Check Point Software Technologies ";
    case ICD.PacificBellDataCommunicationsNetwork:
      return "Pacific Bell Data Communications Network ";
    case ICD.PssObjectIdentifiers:
      return "PSS Object Identifiers ";
    case ICD.StentorIcdCodingSystem:
      return "STENTOR-ICD CODING SYSTEM ";
    case ICD.AtmNetworkZn96:
      return "ATM-Network ZN'96 ";
    case ICD.MciOsiNetwork:
      return "MCI / OSI Network ";
    case ICD.Advantis:
      return "Advantis ";
    case ICD.AffableSoftwareDataInterchangeCodes:
      return "Affable Software Data Interchange Codes ";
    case ICD.BbDataGmbh:
      return "BB-DATA GmbH ";
    case ICD.BasfCompanyAtmNetwork:
      return "BASF Company ATM-Network ";
    case ICD.IotaIdentifiersForOrganizationsForTelecommunicationsAddressingUsingIcdSystemFormatDefinedInIsoIec8348:
      return "IOTA Identifiers for Organizations for Telecommunications Addressing using the ICD system format defined in ISO/IEC 8348 ";
    case ICD.HenkelCorporateNetworkHNet:
      return "Henkel Corporate Network (H-Net) ";
    case ICD.GteOsiNetwork:
      return "GTE/OSI Network ";
    case ICD.DresdnerBankCorporateNetwork:
      return "Dresdner Bank Corporate Network ";
    case ICD.BcnrSwissClearingBankNumber:
      return "BCNR (Swiss Clearing Bank Number) ";
    case ICD.BpiSwissBusinessPartnerIdentificationCode:
      return "BPI (Swiss Business Partner Identification) code ";
    case ICD.DirectoratesEuropeanCommission:
      return "Directorates of the European Commission ";
    case ICD.CodeForIdentificationNationalOrganizations:
      return "Code for the Identification of National Organizations ";
    case ICD.CerticomObjectIdentifiers:
      return "Certicom Object Identifiers ";
    case ICD.Tc68Oid:
      return "TC68 OID ";
    case ICD.InfonetServicesCorporation:
      return "Infonet Services Corporation ";
    case ICD.SiaObjectIdentifiers:
      return "SIA Object Identifiers ";
    case ICD.CableWirelessGlobalAtmEndSystemAddressPlan:
      return "Cable & Wireless Global ATM End-System Address Plan ";
    case ICD.GlobalAesaScheme:
      return "Global AESA scheme ";
    case ICD.FranceTelecomAtmEndSystemAddressPlan:
      return "France Telecom ATM End System Address Plan ";
    case ICD.SavvisCommunicationsAesa:
      return "Savvis Communications AESA:. ";
    case ICD.ToshibaOrganizationsPartnersAndSuppliersTopasCode:
      return "Toshiba Organizations, Partners, And Suppliers' (TOPAS) Code ";
    case ICD.NatoCommercialAndGovernmentEntitySystem:
      return "NATO Commercial and Government Entity system ";
    case ICD.SecetiObjectIdentifiers:
      return "SECETI Object Identifiers ";
    case ICD.EinesteinetAg:
      return "EINESTEINet AG ";
    case ICD.DodaacDepartmentDefenseActivityAddressCode:
      return "DoDAAC (Department of Defense Activity Address Code) ";
    case ICD.DgcpDirectionGénéraleDeLaComptabilitéPubliqueAdministrativeAccountingIdentificationScheme:
      return "DGCP (Direction Générale de la Comptabilité Publique)administrative accounting identification scheme ";
    case ICD.DgiDirectionGénéraleDesImpotsCode:
      return "DGI (Direction Générale des Impots) code ";
    case ICD.StandardCompanyCode:
      return "Standard Company Code ";
    case ICD.ItuInternationalTelecommunicationsUnionDataNetworkIdentificationCodesDnic:
      return "ITU (International Telecommunications Union)Data Network Identification Codes (DNIC) ";
    case ICD.GlobalBusinessIdentifier:
      return "Global Business Identifier ";
    case ICD.MadgeNetworksLtdIcdAtmAddressingScheme:
      return "Madge Networks Ltd- ICD ATM Addressing Scheme ";
    case ICD.AustralianBusinessNumberAbnScheme:
      return "Australian Business Number (ABN) Scheme ";
    case ICD.EdiraSchemeIdentifierCode:
      return "Edira Scheme Identifier Code ";
    case ICD.ConcertGlobalNetworkServicesIcdAesa:
      return "Concert Global Network Services ICD AESA ";
    case ICD.IdentificationNumberEconomicSubjectsIco:
      return "Identification number of economic subjects: (ICO) ";
    case ICD.GlobalCrossingAesaAtmEndSystemAddress:
      return "Global Crossing AESA (ATM End System Address) ";
    case ICD.Auna:
      return "AUNA ";
    case ICD.AtmInterconnectionWithDutchKpnTelecom:
      return "ATM interconnection with the Dutch KPN Telecom ";
    case ICD.IdentificationNumberEconomicSubjectIcoActOnStateStatistics29November200127:
      return "Identification number of economic subject (ICO) Act on State Statistics of 29 November 2'001, § 27 ";
    case ICD.ActalisObjectIdentifiers:
      return "ACTALIS Object Identifiers ";
    case ICD.GtinGlobalTradeItemNumber:
      return "GTIN - Global Trade Item Number ";
    case ICD.EccmaOpenTechnicalDirectory:
      return "ECCMA Open Technical Directory ";
    case ICD.CenIsssObjectIdentifierScheme:
      return "CEN/ISSS Object Identifier Scheme ";
    case ICD.UsEpaFacilityIdentifier:
      return "US-EPA Facility Identifier ";
    case ICD.TelusCorporation:
      return "TELUS Corporation ";
    case ICD.FieieObjectIdentifiers:
      return "FIEIE Object identifiers ";
    case ICD.SwissguideIdentifierScheme:
      return "Swissguide Identifier Scheme ";
    case ICD.PriorityTelecomAtmEndSystemAddressPlan:
      return "Priority Telecom ATM End System Address Plan ";
    case ICD.VodafoneIrelandOsiAddressing:
      return "Vodafone Ireland OSI Addressing ";
    case ICD.SwissFederalBusinessIdentificationNumberCentralBusinessNamesIndexZefixIdentificationNumber:
      return "Swiss Federal Business Identification Number. Central Business names Index (zefix) Identification Number ";
    case ICD.TeikokuCompanyCode:
      return "Teikoku Company Code ";
    case ICD.LuxembourgCpCpsCertificationPolicyAndCertificationPracticeStatementIndex:
      return "Luxembourg CP & CPS (Certification Policy and Certification Practice Statement) Index ";
    case ICD.ProjectGroupListsPropertiesProlist:
      return "Project Group “Lists of Properties” (PROLIST®) ";
    case ICD.EciSs:
      return "eCI@ss ";
    case ICD.Stepnexus:
      return "StepNexus ";
    case ICD.SiemensAg:
      return "Siemens AG ";
    case ICD.ParadineGmbh:
      return "Paradine GmbH ";
    case ICD.OdetteInternationalLimited:
      return "Odette International Limited ";
    case ICD.Route1Mobinet:
      return "Route1 MobiNET ";
    case ICD.PenangoObjectIdentifiers:
      return "Penango Object Identifiers ";
    case ICD.LithuanianMilitaryPki:
      return "Lithuanian military PKI ";
    case ICD.NuméroDidentificationSuisseDesEnterprisesIdeSwissUniqueBusinessIdentificationNumberUidb:
      return "Numéro d'identification suisse des enterprises (IDE), Swiss Unique Business Identification Number (UIDB) ";
    case ICD.Digstorg:
      return "DIGSTORG ";
    case ICD.PercevalObjectCode:
      return "Perceval Object Code ";
    case ICD.TrustpointObjectIdentifiers:
      return "TrustPoint Object Identifiers ";
    case ICD.AmazonUniqueIdentificationScheme:
      return "Amazon Unique Identification Scheme ";
    case ICD.CorporateNumberTheSocialSecurityAndTaxNumberSystem:
      return "Corporate Number of The Social Security and Tax Number System ";
    case ICD.EuropeanBusinessIdentifierEbid:
      return "European Business Identifier (EBID) ";
    case ICD.OrganisatieIndentificatieNummerOin:
      return "Organisatie Indentificatie Nummer (OIN) ";
    case ICD.CompanyCodeEstonia:
      return "Company Code (Estonia) ";
    case ICD.Organisasjonsnummer:
      return "Organisasjonsnummer ";
    case ICD.UblBePartyIdentifier:
      return "UBL.BE Party Identifier ";
    case ICD.KoiosOpenTechnicalDictionary:
      return "KOIOS Open Technical Dictionary";
    case ICD.SingaporeNationwideELnvoiceFramework:
      return "Singapore Nationwide E-lnvoice Framework ";
    case ICD.IcelandicIdentifierÍslenskKennitala:
      return "Icelandic identifier - Íslensk kennitala ";
    case ICD.AppliaPlStandard:
      return "APPLiA Pl Standard";
    case ICD.Erstorg:
      return "ERSTORG";
    case ICD.LegalEntityIdentifierLei:
      return "Legal Entity Identifier (LEI)";
    case ICD.LegalEntityCodeLithuania:
      return "Legal entity code (Lithuania)";
    case ICD.CodiceUnivocoUnitàOrganizzativaIpa:
      return "Codice Univoco Unità Organizzativa iPA";
    case ICD.IndirizzoDiPostaElettronicaCertificata:
      return "Indirizzo di Posta Elettronica Certificata";
    case ICD.EdeliveryNetworkParticipantIdentifier:
      return "eDelivery Network Participant identifier";
    case ICD.LeitwegId:
      return "Leitweg-ID";
    case ICD.Coddest:
      return "CODDEST";
    case ICD.RegistreDuCommerceEtDeLIndustrieRci:
      return "Registre du Commerce et de l’Industrie : RCI";
    case ICD.PilogOntologyCodificationIdentifierPoci:
      return "PiLog Ontology Codification Identifier (POCI)";
    case ICD.NumeroDentrepriseOndernemingsnummerUnternehmensnummer:
      return "Numero d'entreprise / ondernemingsnummer / Unternehmensnummer";
    case ICD.Gs1IdentificationKeys:
      return "GS1 identification keys";
    case ICD.CodiceFiscale:
      return "CODICE FISCALE";
    case ICD.PartitaIva:
      return "PARTITA IVA";
    case ICD.FinnishOrganizationIdentifier:
      return "Finnish Organization Identifier";
    case ICD.FinnishOrganizationValueAddTaxIdentifier:
      return "Finnish Organization Value Add Tax Identifier";
    case ICD.TradeplaceTradepiStandard:
      return "Tradeplace TradePI Standard";
    case ICD.NetServiceId:
      return "Net service ID";
    case ICD.Ovtcode:
      return "OVTcode";
    case ICD.TheNetherlandsChamberCommerceAndIndustryEstablishmentNumber:
      return "The Netherlands Chamber of Commerce and Industry establishment number";
    case ICD.UnifiedRegistrationNumberLatvia:
      return "Unified registration number (Latvia)";
    case ICD.TaxpayerRegistrationCodeLatvia:
      return "Taxpayer registration code (Latvia)";
    case ICD.TheRegisterNaturalPersonsLatvia:
      return "The Register of Natural Persons (Latvia)";
    case ICD.TheRegisteredNumberQualifiedInvoiceIssuer:
      return "The registered number of the qualified invoice issuer";
    case ICD.MetadataRegistrySupport:
      return "Metadata Registry Support";
    case ICD.EuBasedCompany:
      return "EU based company";
    case ICD.FtctcCodeRoutage:
      return "FTCTC CODE ROUTAGE";
    case ICD.FrctcElectronicAddress:
      return "FRCTC ELECTRONIC ADDRESS";
    case ICD.FrctcParticulier:
      return "FRCTC Particulier";
    case ICD.NonEuBasedCompany:
      return "NON - EU based company";
    case ICD.RépertoireDesEntreprisesEtDesEtablissementsRidet:
      return "Répertoire des Entreprises et des Etablissements (RIDET)";
    case ICD.TAHITITraitementAutomatiqueHiérarchiséDesInstitutionsDeTahitiEtDesÎles:
      return "T.A.H.I.T.I (traitement automatique hiérarchisé des institutions de Tahiti et des îles)";
    case ICD.NationalEInvoicingFramework:
      return "National e-Invoicing Framework";
    case ICD.SingleTaxableCompanyFrance:
      return "Single taxable company (France)";
    case ICD.NobbProductNumber:
      return "NOBB product number";
    case ICD.DescriptionNotKnown:
      return "Description not known";
    case ICD.ToimitusosoiteId:
      return "Toimitusosoite ID";
    case ICD.UaeTaxIdentificationNumberTin:
      return "UAE Tax Identification Number (TIN)";
    case ICD.DescriptionNotKnown_Dup:
      return "Description not known";
    case ICD.CprDanishPersonCivilRegistrationNumber:
      return "CPR (Danish person civil registration number)";
    case ICD.PlateformeSAgrééeSÀLaFacturationÉlectroniquePpfPdp:
      return "Plateforme.s agréée.s à la facturation électronique (PPF/PDP)";
    case ICD.Eaeu:
      return "EAEU";
    case ICD.RegisterLegalPersonsInFrenchRépertoireDesPersonnesMorales:
      return "Register of legal persons (in French : Répertoire des personnes morales)";
  }
}
